import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import HistoryBox from './historyBox';
import GameBox from './gameBox';

class HYNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { historyData, gameData },
        } = this.props;

        return (
            <div className={styles.box}>
                <HistoryBox content={historyData} />
                <GameBox content={gameData} />
            </div>
        );
    }
}

export default errorBoundary(HYNews);
